<template>
  <div>
    <trek-loading page :is-loading="loading" />
    <warranty-claim-line-product-details
      :base-properties="baseProperties"
      :claim-line="claimLine"
      :claim-index="claimIndex"
      @issue-types-update="issueTypesUpdate"
    />

    <hr class="rule my-4" />

    <warranty-claim-line-issue-details
      :base-properties="baseProperties"
      :claim-data="claimData"
      :claim-line="claimLine"
      :claim-index="claimIndex"
      :issue-details-enabled="issueDetailsEnabled"
      :warranty-issues="issueTypes"
    />

    <hr class="rule my-4" />

    <warranty-claim-line-attachments
      :base-properties="baseProperties"
      :claim-index="claimIndex"
      :claim-line="claimLine"
    />

    <div class="buttons">
      <trek-button secondary qaid="warranty-claim-line-save" @click="$emit('save-claim')">
        <span v-html="bp('save')"></span>
      </trek-button>
      <trek-button
        v-if="claimData.status !== 'enumClaimStatusActionRequired'"
        tertiary
        qaid="warranty-claim-delete"
        @click="openDeleteDialog"
      >
        <span v-html="bp('deleteClaimLine')"></span>
      </trek-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import {mapMutations} from 'vuex';
import TrekButton from '@/components/TrekButton';
import TrekLoading from '@/components/TrekLoading';
import WarrantyClaimLineAttachments from '@/components/containers/warranty-claim/WarrantyClaimLineAttachments';
import WarrantyClaimLineProductDetails from '@/components/containers/warranty-claim/WarrantyClaimLineProductDetails';
import WarrantyClaimLineIssueDetails from '@/components/containers/warranty-claim/WarrantyClaimLineIssueDetails';

export default {
  components: {
    TrekLoading,
    TrekButton,
    WarrantyClaimLineAttachments,
    WarrantyClaimLineProductDetails,
    WarrantyClaimLineIssueDetails,
  },
  props: {
    baseProperties: {
      type: Array,
      required: true,
    },
    claimData: {
      type: Object,
      required: true,
    },
    claimIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    claimLine: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      issueDetailsEnabled: false,
      issueTypes: [],
      loading: false,
    };
  },

  mounted() {
    this.initializeIssueTypes();
  },

  methods: {
    issueTypesUpdate(warrantyIssues) {
      this.issueTypes = warrantyIssues || [];
      this.issueDetailsEnabled = true;
    },

    openDeleteDialog() {
      this.$emit('open-delete-dialog', this.claimLine.id);
    },

    initializeIssueTypes() {
      // Retrieve the warranty issue types depending on product type selected and if the serial or sku exist
      if (this.claimLine.productType === 'Bikes' && this.claimLine.serialNumber)
        this.retrieveIssueTypes('serial', this.claimLine.serialNumber);
      else if (this.claimLine.productType === 'PartsAndAccessories' && this.claimLine.sku)
        this.retrieveIssueTypes('sku', this.claimLine.sku);

      if (this.claimLine && this.claimLine.issueTypeNameSelected && this.claimLine.issueTypeNameSelected.length)
        this.issueDetailsEnabled = true;
    },

    retrieveIssueTypes(type, serialOrSku) {
      this.loading = true;
      this.setUseToastInterceptor(false);
      axios
        .get(`/claims/${type}/${serialOrSku}/`)
        .then((response) => {
          if (!isEmpty(response.data.data)) this.issueTypesUpdate(response.data.data.warrantyIssues);
        })
        .finally(() => {
          this.loading = false;
          this.setUseToastInterceptor(true);
        });
    },

    ...mapMutations('global', ['setUseToastInterceptor']),
  },
};
</script>
